// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataModelAccess.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import DataModelAccessTree from './Izenda.RoleDataModelAccessTree';

function DataModelAccess(props: any) {
  const { store, dataModelAccess, readOnly, localization } = props;

  return (
    <div className="izenda-Wrapper">
      <div className="izenda-Wrapper-header">
        <div className="u_paddingTopBottom">{localization.getText('ROLE_SETUP_DATA_MODEL_HEADER')}</div>
      </div>

      <div className="izenda-Wrapper-content u_paddingLeftRight">
        <DataModelAccessTree dataModel={dataModelAccess} readOnly={readOnly} store={store} />
      </div>
    </div>
  );
}

export default connect()(DataModelAccess);



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/DataModelAccess/Izenda.DataModelAccess.jsx